










import Vue from 'vue'
import { store } from '@/store'
import SpectraOfFeature from '@/components/SpectraOfFeature.vue'
import MotifsOfFeature from '@/components/MotifsOfFeature.vue'

export default Vue.extend({
    components: {
        SpectraOfFeature,
        MotifsOfFeature
    },
    computed: {
        id() {
            return this.$route.params.name;
        },
        range() {
            const id = this.$route.params.name;
            return store.state.dataset.features[id];
        }
    }
})
